import moment from "moment";
import { DATE_TIME_FORMAT } from "./constants";

export default (value) => {
  if (value) {
    return moment.utc(String(value)).format(DATE_TIME_FORMAT);
  }
  return "";
};
